/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

export * from "./ErrorPage";
export * from "./ErrorPageProps";
